import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CONSTANTS } from '../constants/constants';
@Injectable({
  providedIn: 'root',
})
export class NavigationManagerService {
  private stepSharedData = {
    step: 1,
    prevStep: 0,
  };

  private navigationManagerDataSubject = new BehaviorSubject<any>(
    this.stepSharedData
  );
  currentData = this.navigationManagerDataSubject.asObservable();
  currentValue = this.navigationManagerDataSubject.getValue();

  constructor() {}

  /**
   * @description: setStepSiteManager function accepts action as argument and set the step for Modal to show.
   * @input { string }
   * @param { action  }
   * @output { void }
   */

  setStepSiteManager(action: string, currentStep?: number) {
    let valueForUpdate = this.currentValue;
    if (action === CONSTANTS.SITE) valueForUpdate.step = 1;
    else if (action === CONSTANTS.BUILDING) valueForUpdate.step = 2;
    else if (action === CONSTANTS.FLOOR) valueForUpdate.step = 3;
    else if (action === CONSTANTS.UNIT_MANAGAEMENT) valueForUpdate.step = 4;
    else if (action === CONSTANTS.REMOVE_UNIT) valueForUpdate.step = 5;
    else if (action === CONSTANTS.EDIT_UNIT) valueForUpdate.step = 6;
    else if (action === CONSTANTS.FILTER_UNIT) valueForUpdate.step = 7;
    else if (action === CONSTANTS.MASTER_CREDENTIAL) valueForUpdate.step = 8;
    else if (action === CONSTANTS.MASTER_CREDENTIAL_DETAIL)
      valueForUpdate.step = 9;
    else if (action === CONSTANTS.EDIT_MASTER_CREDENTIAL)
      valueForUpdate.step = 10;
    else if (action === CONSTANTS.ACTIVITY) valueForUpdate.step = 11;
    else if (action === CONSTANTS.RESET) valueForUpdate.step = 1;
    else if (action === CONSTANTS.CONFIRM_DIALOG) {
      valueForUpdate.step = currentStep;
      valueForUpdate.prevStep = 1;
    } else if (action === CONSTANTS.CLOSE_CONFIRM_DIALOG) {
      valueForUpdate.step = currentStep;
      valueForUpdate.prevStep = 0;
    }

    this.navigationManagerDataSubject.next(valueForUpdate);
  }
}
